<script>
  export let size = 24;
  export let color = '#ffffff';
</script>

<svg 
  class="video-play-icon" 
  width={size} 
  height={size} 
  viewBox="0 0 24 24" 
  fill="none" 
  xmlns="http://www.w3.org/2000/svg"
>
  <path 
    d="M8 5.14v14l11-7-11-7z" 
    fill={color}
  />
</svg> 